import { render, staticRenderFns } from "./airtime.vue?vue&type=template&id=06f9131a"
import script from "./airtime.vue?vue&type=script&lang=js"
export * from "./airtime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports